// extracted by mini-css-extract-plugin
module.exports = {"list":"provider-games_list__yVa17"};